"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconLocation = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconLocation = function IconLocation(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.068 12.31c-1.763 0-3.193-1.44-3.193-3.217 0-1.778 1.43-3.217 3.193-3.217 1.763 0 3.194 1.44 3.194 3.217 0 1.776-1.43 3.216-3.194 3.216m0-10.309C8.164 2 5 5.187 5 9.12c0 3.713 3.201 8.504 5.339 10.836.798.87 1.728 2.044 1.728 2.044s1-1.18 1.857-2.076c2.136-2.235 5.212-6.723 5.212-10.805C19.136 5.187 15.97 2 12.068 2"
  }));
};
exports.IconLocation = IconLocation;